<form #eventForm="ngForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="flex items-center justify-center dialog-header ">
        Create WhatsApp Template

        <div class="absolute right-2">
            <button (click)="handleCloseDialog()" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>

    </div>

    <div class="dialog-content">
        <div class="flex flex-col lg:flex-row gap-3">
            <div class="left-box  lg:w-[65%] lg:h-[75vh] overflow-x-hidden pr-2">
                <div class="sample_Card">
                    <div class="text-label">Template Name *</div>
                    <div class="sub_text">Give your message template a name.</div>
                    <input type="text" pInputText disabled="{{type === 'Edit'}}" [(ngModel)]="template.template_name"
                        name="template_name" #template_name="ngModel" class="w-full mt-3 mb-3" required
                        pattern="^[a-z0-9_]+$" />

                    <div *ngIf="template_name.errors && isSubmitted" class="errors">
                        <div *ngIf="template_name.errors['required']">Template Name is required</div>
                    </div>
                    <div class="errors" *ngIf="template_name?.errors?.['pattern']">Template Name can only contain small
                        letters, numbers, and underscores</div>
                </div>

                <div class="sample_Card">
                    <div class="text-label">Category*</div>
                    <div class="sub_text">Choose what type of message template you want to create.</div>

                    <div class="grid grid-cols-1 md:grid-cols-3 gap-3 mt-4">
                        <div class="category_item">
                            <div>
                                <p-radioButton name="category" value="MARKETING" [(ngModel)]="template.category"
                                    [disabled]="type === 'Edit'" label="Marketing" required
                                    inputId="cat1"></p-radioButton>
                                <label for="cat1" class="ml-2">Marketing</label>
                            </div>
                            <div class="text-sm text-gray-500">
                                Send promo offers, product offers and more to increase awareness and engagement.
                            </div>
                        </div>
                    </div>


                    <div *ngIf="template.category === '' && isSubmitted" class="errors">
                        <div>Category is required</div>
                    </div>


                </div>

                <div class="sample_Card">
                    <div class="text-label">Language *</div>
                    <div class="sub_text">Choose which languages your message template will be sent in.</div>
                    <p-select [options]="languagesList" [(ngModel)]="template.language" optionLabel="language"
                        name="language" #language="ngModel" required optionValue="code" class="w-full mt-3 mb-3" />

                    <div *ngIf="language.errors && isSubmitted" class="errors">
                        <div *ngIf="language.errors['required']">Language is required</div>
                    </div>
                </div>

                <div class="sample_Card">
                    <div class="text-label">Template Labels *</div>
                    <div class="sub_text">Define what use-case does this template serves e.g Account update, OTP, etc in
                        2-3 words</div>
                    <input type="text" pInputText disabled="{{type === 'Edit'}}" [(ngModel)]="template.labels"
                        name="template_labels" #template_labels="ngModel" class="w-full mt-3 mb-3" required />

                    <div *ngIf="template_labels.errors && isSubmitted" class="errors">
                        <div *ngIf="template_labels.errors['required']">Template Labels are required</div>
                    </div>
                </div>

                <div class="sample_Card">
                    <div class="text-label">Header *</div>
                    <div class="sub_text">
                        Add a 60 character title to your message. Only one variable is supported in the header.
                    </div>

                    <p-select appendTo="body" [options]="headerOptions" [(ngModel)]="template.header"
                        placeholder="Select Header Type" name="header" #header="ngModel" class="w-full mt-3 mb-3"
                        required></p-select>

                    <input type="text" pInputText class="w-full mb-2 mt-3" *ngIf="template.header === 'text'"
                        [(ngModel)]="template.header_text" name="template_header_text" #template_labels="ngModel"
                        placeholder="Enter Header Text" required />

                        <div *ngIf="template.header_text && !isValidHeaderText(template.header_text)"
                        class="errors"
                        >
                            The message header can’t have any new lines, formatted characters, emojis or asterisks
                        </div>


                    <div *ngIf="template.header === 'media'" class="grid lg:grid-cols-4 grid-cols-2 gap-3 mt-3">

                        <div class="item_boxx">
                            <div>
                                <p-radiobutton name="media" value="image" [(ngModel)]="template.media"
                                    inputId="image" />
                            </div>

                            <div class="media_box" (click)="selectMedia('image')">
                                <div>
                                    <i class="pi pi-image media_box_image"></i>
                                </div>
                                <div class="media_box_image_title">
                                    Image
                                </div>
                            </div>

                        </div>

                        <div class="item_boxx">
                            <div>
                                <p-radiobutton name="media" value="video" [(ngModel)]="template.media"
                                    inputId="video" />
                            </div>

                            <div class="media_box" (click)="selectMedia('video')">
                                <div>
                                    <i class="pi pi-video media_box_image"></i>
                                </div>
                                <div class="media_box_image_title">
                                    Video
                                </div>
                            </div>

                        </div>

                        <div class="item_boxx">
                            <div>
                                <p-radiobutton name="media" value="document" [(ngModel)]="template.media"
                                    inputId="document" />
                            </div>

                            <div class="media_box" (click)="selectMedia('document')">
                                <div>

                                    <i class="pi pi-file media_box_image"></i>
                                </div>
                                <div class="media_box_image_title">
                                    Document
                                </div>
                            </div>

                        </div>

                        <div class="item_boxx">
                            <div>
                                <p-radiobutton name="media" value="location" [(ngModel)]="template.media"
                                    inputId="location" />
                            </div>

                            <div class="media_box" (click)="selectMedia('location')">
                                <div>
                                    <i class="pi pi-map-marker media_box_image"></i>
                                </div>
                                <div class="media_box_image_title">
                                    Location
                                </div>
                            </div>

                        </div>


                        <!-- show error -->



                    </div>

                    <div *ngIf="template.header === 'media'">
                        <div *ngIf="template.media === '' && isSubmitted" class="errors">
                            <div>Media is required</div>
                        </div>
                    </div>

                    <div *ngIf="header.errors && isSubmitted" class="errors">
                        <div *ngIf="header.errors['required']">Header is required</div>
                    </div>
                </div>

                <div class="sample_Card"
                    *ngIf="template.header === 'media' && ['image', 'video', 'document'].includes(template.media)">
                    <div class="text-label">Add Sample Media*</div>

                    <div *ngIf="template.mediaData === ''; else showmedia" class="mt-4">
                        <p-fileUpload mode="basic" chooseLabel="Browse" chooseIcon="pi pi-upload"
                            (onSelect)="onFileChange($event)" [accept]="acceptedFileTypes()"
                            [maxFileSize]="maxFileSize()" name="file" class="w-full" required></p-fileUpload>
                    </div>

                    <ng-template #showmedia>
                        <div class="media-box-preview-item" *ngIf="!showMediaThroughMediaID">
                            <img *ngIf="template.media === 'image'" [src]="template.mediaData" alt="media"
                                class="media-preview" />
                            <video *ngIf="template.media === 'video'" [src]="template.mediaData" controls
                                class="media-preview"></video>
                            <!-- <iframe *ngIf="template.media === 'document'" class="media-preview"></iframe> -->
                            <i *ngIf="template.media === 'document'" class="pi pi-file
                            media-preview" style="font-size: 70px; color: red;"></i>
                            <div *ngIf="template.media === 'document'" style="color: red;
                            font-size: 20px;
                            margin-top: -55px;"> Pdf </div>

                            <div class="media-box-action">
                                <div>Only one sample media is allowed</div>
                                <button type="button" pButton label="Remove" icon="pi pi-trash" class="p-button-danger"
                                    (click)="removeMedia()"></button>
                            </div>
                        </div>


                        <div class="media-box-preview-item" *ngIf="showMediaThroughMediaID">
                            <img *ngIf="template.media === 'image'"
                                [src]="'https://api.gupshup.io/wa/184ca697-c88c-426f-8b06-b802c7ceaff3/wa/media/' + mediaId + '?download=false'"
                                alt="media" class="media-preview" />

                            <video *ngIf="template.media === 'video'"
                                [src]="'https://api.gupshup.io/wa/184ca697-c88c-426f-8b06-b802c7ceaff3/wa/media/' + mediaId + '?download=false'"
                                alt="media" controls class="media-preview">

                            </video>

                            <iframe *ngIf="template.media === 'document'"
                                [src]="'https://api.gupshup.io/wa/184ca697-c88c-426f-8b06-b802c7ceaff3/wa/media/' + mediaId + '?download=false' | safeUrl"
                                width="100%" height="200px"></iframe>

                            <div class="media-box-action">
                                <div>Only one sample media is allowed</div>
                                <button type="button" pButton label="Remove" icon="pi pi-trash" class="p-button-danger"
                                    (click)="removeMedia()"></button>
                            </div>


                        </div>

                    </ng-template>

                    <div class="bg-orange-50 dark:bg-transparent 
                    dark:border-orange-50 dark:text-orange-50 dark:border 
                    p-4 mt-6 mb-2 rounded-lg text-sm leading-7">

                        <div>
                            <span class="font-semibold">Note:</span>
                            Following are the file formats and their respective sizes which are accepted for upload
                        </div>

                        <div>
                            1. <span class="font-semibold">Image:</span> JPEG and PNG (Max size 2 MB)
                        </div>

                        <div>
                            2. <span class="font-semibold">Video:</span> MP4 (Max size 20 MB)
                        </div>

                        <div>
                            3. <span class="font-semibold">Document:</span> (Max size 2 MB)
                        </div>

                        <div *ngIf="template.mediaData === '' && isSubmitted" class="text-red-500 mt-2">
                            <div>Media is required</div>
                        </div>

                    </div>


                    <div class="errors" *ngIf="template.mediaData === '' && isSubmitted">
                        <div>Media is required</div>
                    </div>
                </div>

                <div class="sample_Card">
                    <div class="text-label">Body *</div>
                    <div class="sub_text mb-4">Enter the text for your message in the language you have selected.</div>

                    <p-editor 
                    [modules]="editorConfig"
                    #editor [style]="{ height: '200px' }" (ngModelChange)="onEditorChange()" class="mt-4 mb-4"
                        required></p-editor>

                    <p-button (click)="insertVariable()" [style]="{marginTop: '15px'}" icon="pi pi-plus"
                        label="Add Variable"></p-button>

                    <div *ngIf="objectKeys(variables).length > 0">
                        <p-divider></p-divider>
                        <div class="text-label mt-4 mb-2">
                            Define sample variable value for body
                        </div>
                    </div>

                    <div *ngFor="let variable of objectKeys(variables)">
                        <div style="display: flex; gap: 10px; align-items: center;" class="mt-4">
                            <div class="variable-heading" style="width: 50px;">{{ variable }}:</div>
                            <input pInputText [(ngModel)]="variables[variable]" name="{{ variable }}"
                                (ngModelChange)="updateRenderedData()" placeholder="Enter sample value" />
                            <p-select 
                                [options]="contactGroupColumns" 
                                [(ngModel)]="variableMapping[variable]" 
                                name="mapping_{{ variable }}"
                                optionLabel="label" 
                                optionValue="value"
                                placeholder="Select column"
                                [style]="{ minWidth: '200px' }"
                                appendTo="body">
                            </p-select>
                        </div>

                    </div>

                    <div *ngIf="editorData.length == 0 && isSubmitted" class="errors mt-2">
                        Body is required
                    </div>

                    <!-- //erorr for variable if any variable not have value -->
                    <div *ngIf="variableError && isSubmitted" class="errors mt-2">
                        <div>Variable value is required</div>
                    </div>
                </div>

                <div class="sample_Card">
                    <div class="text-label">Footer</div>
                    <div class="sub_text">Add a 60 character footer to your message. Variables are not supported in the
                        footer</div>
                    <input type="text" pInputText [(ngModel)]="template.footer" name="footer" #footer="ngModel"
                        placeholder="Footer" class="w-full mt-3 mb-3" />
                </div>

                <div class="sample_Card">
                    <div class="text-label">Buttons</div>
                    <div class="sub_text"> Please choose buttons to be added to the template. You can choose upto 10
                        buttons.</div>

                    <div class="grid md:grid-cols-4 grid-cols-2 gap-3 mt-4">
                        <button pButton type="button" class="p-button p-button-primary"
                            (click)="addQuickReplyButton($event)">
                            <i class="pi pi-plus mr-1"></i> Quick Reply
                        </button>
                        <button pButton type="button" class="p-button p-button-primary" (click)="addUrlButton($event)">
                            <i class="pi pi-plus mr-1"></i> Add URL
                        </button>
                        <button pButton type="button" class="p-button p-button-primary" (click)="addCallButton($event)">
                            <i class="pi pi-plus mr-1"></i> Add Phone Number
                        </button>
                    </div>

                    <div *ngIf="countQuickReplyButton !== 0">
                        <div class="quickreply_button_container">
                            <div class="quick_reply_heading">Quick Reply</div>

                            <div *ngFor="let item of quickReplyButtons; let i = index" class="quick_reply_box">
                                <input pInputText type="text" class="form-control mb-1 w-full" [(ngModel)]="item.value"
                                    name="template_name_{{i}}" placeholder="Quick Reply Title" required />
                                <button pButton type="button" class="p-button p-button-danger p-button-sm "
                                    style="position: absolute; top: 2px; right: -52px;"
                                    (click)="removeQuickReplyButton($event,i)">
                                    <i class="pi pi-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="countCTAButtonForCall + countCTAButtonForURL !== 0">
                        <div class="quickreply_button_container">
                            <div class="quick_reply_heading">Call to action</div>

                            <div *ngFor="let item of urlButtons; let i = index" class="quick_reply_box"
                                style="position: relative;">
                                <div class="flex gap-2">
                                    <input pInputText type="text" class="form-control mb-1 w-full"
                                        [(ngModel)]="item.title" name="title_url_{{i}}" placeholder="Quick Reply Title"
                                        required />
                                    <!-- <p-select [(ngModel)]="item.urlType" [options]="urlTypeOptions"
                                        placeholder="Select URL Type" class="w-full"></p-select> -->
                                    <input pInputText type="text" class="form-control mb-1 w-full"
                                        [(ngModel)]="item.value" name="url_{{i}}" placeholder="Enter URL"
                                        pattern="https?://.+" #urlInput="ngModel" required />
                                    <div *ngIf="urlInput.invalid && item?.url?.length > 0" class="text-red-500 text-xs">
                                        Please enter a valid URL.
                                    </div>
                                </div>

                                <!-- <div *ngIf="item.urlType === 'dynamic'" class="mt-3 mb-4 text-red-500 text-xs">
                                    Sample dynamic URL with variable<br />
                                    (Note: Do not add the URL in your sample message body above)
                                </div>

                                <div class="flex gap-2 items-center" *ngIf="item.urlType === 'dynamic'">
                                    <div>1.</div>
                                    <input pInputText type="text" class="form-control" [(ngModel)]="item.suffix"
                                        name="dynamicUrl_{{i}}" placeholder="Enter Suffix" required />
                                    <i class="pi pi-info-circle"
                                        data-p-tooltip="This will add dynamic content at the end of the URL. Example: https://gravitas.ai/[dynamicPath] -> https://gravitas.ai/product, https://gravitas.ai/about"></i>
                                </div> -->

                                <button pButton type="button" class="p-button p-button-danger p-button-sm"
                                    style="position: absolute; top: 2px; right: -52px;"
                                    (click)="removeUrlButton($event,i)">
                                    <i class="pi pi-trash"></i>
                                </button>
                            </div>

                            <div *ngFor="let item of callButtons; let i = index" class="quick_reply_box"
                                style="position: relative;">
                                <div class="flex gap-2">
                                    <input pInputText type="text" class="form-control mb-1 w-full"
                                        [(ngModel)]="item.title" name="title_call_{{i}}" placeholder="Button Title"
                                        required />
                                    <input pInputText type="number" class="form-control mb-1 w-full"
                                        [(ngModel)]="item.value" name="call_{{i}}" placeholder="Type Button Value"
                                        required />
                                </div>
                                <button pButton type="button" class="p-button p-button-danger p-button-sm"
                                    style="position: absolute; top: 2px; right: -52px;"
                                    (click)="removeCallButton($event,i)">
                                    <i class="pi pi-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>


                <div class="w-full">
                    <p-button type="submit" label="Save" [style]="{width: '100%',
                    marginTop: '15px'
                    }" [loading]="btnLoading" icon="pi pi-save" (onClick)="handleSubmit(eventForm)"
                        class="w-full mt-4"></p-button>
                </div>


            </div>

            <div class="right-box lg:w-[35%] mt-5 lg:mt-0 h-[75vh] overflow-x-hidden">
                <div class="right-side-box relative">
                    <div class="whatsapp-ui-box">
                        <div class="dark:dark-overlay light:hidden dark:absolute dark:block"></div>
                        <div class="font-bold text-lg text-black">
                            Preview
                        </div>

                        <div class="preview-box">

                            <div
                                *ngIf="template.header === 'media' && (template.media === 'image' || template.media === 'video' || template.media === 'document') && !showMediaThroughMediaID">
                                <div *ngIf="template.media=== 'image'" class="header_Text">

                                    <ng-container *ngIf="template.mediaData; else noImage">
                                        <img [src]="template.mediaData" alt="media" style="max-width: 100%;
                                        height: 187px;
                                        object-fit: fill;
                                        width: 100%;
                                        border-radius: 10px;" />
                                    </ng-container>
                                    <ng-template #noImage>
                                        <div class="flex justify-center h-[91px] items-center bg-gray-100 rounded-md">
                                            <!-- <img src="assets/img/Gallary.png" alt="media" styleClass="w-[50px] h-[50px] object-contain" /> -->
                                            <i class="pi pi-image" style="font-size: 50px; "></i>
                                        </div>
                                    </ng-template>
                                </div>

                                <div *ngIf="template.media=== 'video'" class="header_Text">
                                    <ng-container *ngIf="template.mediaData; else noVideo">
                                        <video [src]="template.mediaData" controls
                                            class="w-full h-[180px] object-cover rounded-md"></video>
                                    </ng-container>
                                    <ng-template #noVideo>
                                        <div class="flex justify-center h-[91px] items-center bg-gray-100 rounded-md">
                                            <!-- <img src="assets/img/video.png" alt="media" styleClass="w-[50px] h-[50px] object-contain" /> -->
                                            <i class="pi pi-video" style="font-size: 50px; "></i>
                                        </div>
                                    </ng-template>
                                </div>

                                <div *ngIf="template.media=== 'document'" class="header_Text">
                                    <ng-container *ngIf="template.mediaData; else noDocument">
                                        <i *ngIf="template.media === 'document'" class="pi pi-file" style="font-size: 70px; 
                                        display: flex;
                                        align-items: center;
                                        margin-top: 10px;
                                        justify-content: center;
                                        color: red;"></i>
                                        <div *ngIf="template.media === 'document'" style="color: red;
                                        font-size: 20px;
                                        text-align: center;
                                        margin-top: 10px;"> Pdf </div>
                                    </ng-container>
                                    <ng-template #noDocument>
                                        <div class="flex justify-center h-[91px] items-center bg-gray-100 rounded-md">
                                            <!-- <img src="assets/img/document.png" alt="media" styleClass="w-[50px] h-[50px] object-contain" /> -->
                                            <i class="pi pi-file" style="font-size: 50px; "></i>

                                        </div>
                                    </ng-template>
                                </div>
                            </div>

                            <div *ngIf="showMediaThroughMediaID">
                                <!-- IMAGE -->
                                <div *ngIf="templateDataToEdit.templateType === 'IMAGE'" class="header_Text">
                                    <ng-container *ngIf="mediaId; else noImage">
                                        <img [src]="'https://api.gupshup.io/wa/184ca697-c88c-426f-8b06-b802c7ceaff3/wa/media/' + mediaId + '?download=false'"
                                            alt="media" style="max-width: 100%;
                                    height: 187px;
                                    object-fit: fill;
                                    width: 100%;
                                    border-radius: 10px;" />
                                    </ng-container>
                                    <ng-template #noImage>
                                        <div class="flex justify-center h-[91px] items-center bg-gray-100 rounded-md">
                                            <!-- <img src="assets/img/Gallary.png" alt="media" styleClass="w-[50px] h-[50px] object-contain" /> -->
                                            <i class="pi pi-image" style="font-size: 50px; "></i>
                                        </div>
                                    </ng-template>
                                </div>

                                <!-- VIDEO -->
                                <div *ngIf="templateDataToEdit.templateType === 'VIDEO'" class="header_Text">
                                    <ng-container *ngIf="mediaId; else noVideo">
                                        <video
                                            [src]="'https://api.gupshup.io/wa/184ca697-c88c-426f-8b06-b802c7ceaff3/wa/media/' + mediaId + '?download=false'"
                                            controls class="w-full h-[180px] object-cover rounded-md"></video>
                                    </ng-container>
                                    <ng-template #noVideo>
                                        <div class="flex justify-center h-[91px] items-center bg-gray-100 rounded-md">
                                            <!-- <img src="assets/img/video.png" alt="media" styleClass="w-[50px] h-[50px] object-contain" /> -->
                                            <i class="pi pi-video" style="font-size: 50px; "></i>
                                        </div>
                                    </ng-template>
                                </div>

                                <!-- DOCUMENT -->
                                <div *ngIf="templateDataToEdit.templateType === 'DOCUMENT'" class="header_Text">
                                    <ng-container *ngIf="mediaId; else noDocument">

                                        <iframe
                                            [src]="'https://api.gupshup.io/wa/184ca697-c88c-426f-8b06-b802c7ceaff3/wa/media/' + mediaId + '?download=false' | safeUrl"
                                            width="100%" height="220px"></iframe>
                                    </ng-container>
                                    <ng-template #noDocument>
                                        <div class="flex justify-center h-[91px] items-center bg-gray-100 rounded-md">
                                            <!-- <img src="assets/img/document.png" alt="media" styleClass="w-[50px] h-[50px] object-contain" /> -->
                                            <i class="pi pi-file" style="font-size: 50px; "></i>

                                        </div>
                                    </ng-template>
                                </div>


                            </div>


                            <div *ngIf="template.header === 'text'" class="header_Text">
                                {{ template.header_text }}
                            </div>

                            <div class="body_Text" [innerHTML]="renderedData">
                            </div>

                            <div class="body_Text footer_Text">
                                {{ template.footer }}
                            </div>

                            <div>
                                <div class="timeText">
                                    {{currentTime}}
                                </div>
                            </div>

                            <div class="buttons_ui">
                                <div class="text-center border-t border-gray-200 pb-1 action_text pt-1 text-sm"
                                    *ngFor="let item of quickReplyButtons.slice(0,2)">
                                    <i class="pi pi-reply action_icon"></i> {{item.value}}
                                </div>
                                <div *ngIf="quickReplyButtons.length < 2">
                                    <div class="text-center border-t border-gray-200 pb-1 action_text pt-1 text-sm"
                                        *ngFor="let item of urlButtons.slice(0,2-quickReplyButtons.length)">
                                        <i class="pi pi-external-link action_icon"></i> {{item.title}}
                                    </div>
                                </div>

                                <div *ngIf="quickReplyButtons.length < 2 && urlButtons.length < 2">
                                    <div class="text-center border-t border-gray-200 pb-1 action_text pt-1 text-sm"
                                        *ngFor="let item of callButtons">
                                        <i class="pi pi-phone action_icon"></i> {{item.title}}
                                    </div>
                                </div>

                                <div class="text-center border-t border-gray-200 pb-1 pt-2 action_text cursor-pointer"
                                    (click)="showAllOptions()"
                                    *ngIf="quickReplyButtons.length + urlButtons.length + callButtons.length > 2">
                                    <i class="pi pi-bars action_text"></i> see all option
                                </div>
                            </div>


                        </div>
                        <div class="absolute bottom-0 left-0 bg-white w-full rounded-b-md pt-3 pb-5 z-10"
                            *ngIf="showAllVariables">
                            <div class="text-center pb-2 relative text-black font-semibold">
                                All Options
                                <i class="pi pi-times absolute top-0 right-4 cursor-pointer text-black"
                                    (click)="showAllOptions()"></i>
                            </div>

                            <div class="text-center border-b border-gray-200 pb-1 pt-1 action_text"
                                *ngFor="let item of quickReplyButtons">
                                <i class="pi pi-reply action_icon"></i> {{item.value}}
                            </div>
                            <div>
                                <div class="text-center border-b border-gray-200 pb-1 pt-1 action_text"
                                    *ngFor="let item of urlButtons">
                                    <i class="pi pi-external-link action_icon"></i> {{item.title}}
                                </div>
                            </div>

                            <div class="text-center border-b border-gray-200 pb-1 pt-1 action_text"
                                *ngFor="let item of callButtons">
                                <i class="pi pi-phone action_icon"></i> {{item.title}}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</form>